module.exports = __webpack_public_path__ + "static/media/withdraw2.d6bcdb43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/withdraw2.svg
// module id = 460
// module chunks = 0